import template	from "./dialog-userscripts.html";
import css		from "./dialog-userscripts.css";

import Dialog	from "dialog";
import MyCodeMirror from "../controls/codemirror-withsyntaxhighlight.js";


class UserscriptsDialog extends Dialog {
  static get template() {
    return template;
  }
  static get css() {
    return css;
  }
  static constructor() {
    customElements.define("fulljs-dialog-userscripts", UserscriptsDialog);
  }
  
  constructor(...args) {
    super(...args);    
    this.__show(...args);
  }
  async __show(...args) {
    var string = await server.rcall("RM_userscript_load");
    this.codemirror.value = string;
    this.show(...args);
  }
  async buttonSave_click() {
    await server.rcall("RM_userscript_save", this.codemirror.value);
  }
  buttonClose_click() {
    this.close();
  }
}

UserscriptsDialog.constructor();

export default UserscriptsDialog;